<h2 mat-dialog-title>
    <mat-icon class="title-icon">folder_open</mat-icon>
    You have {{ drafts.length }} drafts in progress
</h2>

<mat-dialog-content class="picker-content">
    <p class="hint">
        You can have up to 3 organization drafts on the go at once. Open one to keep working on it, or trash one
        to free up a slot for a brand-new draft.
    </p>

    <ul class="drafts-list">
        <li *ngFor="let draft of drafts" class="draft-row" [class.is-busy]="busyKey === draft.key">
            <div class="draft-row__main">
                <div class="draft-row__name">{{ displayName(draft) }}</div>
                <div class="draft-row__meta">
                    <span class="meta-chip"><mat-icon>schedule</mat-icon> Step {{ draft.currentStep }} — {{ stepLabel(draft.currentStep) }}</span>
                    <span class="meta-chip" *ngIf="lastModified(draft) as lm">
                        <mat-icon>history</mat-icon> Modified {{ lm | date: 'MMM d, h:mm a' }}
                    </span>
                    <span
                        class="meta-chip"
                        [class.meta-chip--warn]="expiresIn(draft) <= 7"
                        *ngIf="hasExpiry(draft)"
                    >
                        <mat-icon>hourglass_bottom</mat-icon> Expires in {{ expiresIn(draft) }} day{{ expiresIn(draft) === 1 ? '' : 's' }}
                    </span>
                </div>
            </div>
            <div class="draft-row__actions">
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="open(draft)"
                    [disabled]="busyKey === draft.key"
                >
                    <mat-icon>open_in_new</mat-icon>
                    Open
                </button>
                <button
                    mat-stroked-button
                    color="warn"
                    type="button"
                    (click)="trash(draft)"
                    [disabled]="busyKey === draft.key"
                    matTooltip="Delete this draft (frees a slot)"
                >
                    <mat-icon>delete_outline</mat-icon>
                    Trash
                </button>
            </div>
        </li>
    </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Close</button>
</mat-dialog-actions>
